/**
 * These are Inputs for the cost calculations
 * Unlike safety and delay costs, planning cost only incurs in start year. No discount factor needed.
 * @param {number}  designCost  //Page 6
 * @param {number} constructionCost //Design cost and construction cost are combined on Page 6
 * @param {number}  rightOfWayCost right of way Cost //Page 6
 * @returns {number} - Planning Construction Costs Total
 */
export const getPlanningConstructionCostsTotal = ({
  designCost,
  constructionCost,
  rightOfWayCost,
}) => {
  return designCost + constructionCost + rightOfWayCost;
};
